module.exports = __webpack_public_path__ + "img/GH-kyujin-top-032.87f9cecd.webp";